export const UNSET_VALUE = '-';
export const AMPLITUDE_PREFIX = 'AMP';
export const STORAGE_PREFIX = `${AMPLITUDE_PREFIX}_unsent`;
export const AMPLITUDE_SERVER_URL = 'https://api2.amplitude.com/2/httpapi';
export const EU_AMPLITUDE_SERVER_URL = 'https://api.eu.amplitude.com/2/httpapi';
export const AMPLITUDE_BATCH_SERVER_URL = 'https://api2.amplitude.com/batch';
export const EU_AMPLITUDE_BATCH_SERVER_URL = 'https://api.eu.amplitude.com/batch';
